<kodit-card-container>
  <div card-title>Opšta pravila</div>

  <div card-right-side>
    <button
      icon="far fa-edit"
      pButton
      type="button"
      label="Izmeni"
      class="p-button p-button-outlined"
      (click)="onEdit()"
    ></button>
  </div>

  <div class="p-d-flex p-jc-between" card-body *ngIf="opstaPravilaDto">
    <div class="p-d-flex p-flex-column gap-6">

      <kodit-card-body-icon
        [isOk]="opstaPravilaDto.barkodSkener"
        label="Pretraga artikala sa bar kod čitačem"
        okIconClass="kodit-success fas fa-check"
        notOkIconClass="kodit-error fas fa-minus"
      ></kodit-card-body-icon>

      <kodit-card-body-icon
        class="p-mt-2"
        [isOk]="opstaPravilaDto.stampanje"
        label="Štampanje računa nakon fiskalizacije"
        okIconClass="kodit-success fas fa-check"
        notOkIconClass="kodit-error fas fa-minus"
      ></kodit-card-body-icon>

      <kodit-card-body-text
        label="Veličina papira"
        [text]="opstaPravilaDto.velicinaPapiraDto.velicinaPapiraStr"
      ></kodit-card-body-text>

      <kodit-card-body-text
        label="Popust"
        [text]="opstaPravilaDto.prikazRabataDto.prikazRabataStr"
      ></kodit-card-body-text>

      <kodit-card-body-text
        label="Akcija nakon fiskalizacije"
        [text]="opstaPravilaDto.postFiskalizacijeAkcijaDto.postFiskalizacijeAkcijaStr"
      ></kodit-card-body-text>
    </div>
  </div>

</kodit-card-container>
